import { render, staticRenderFns } from "./EventStatuses.vue?vue&type=template&id=545eced3&"
import script from "./EventStatuses.vue?vue&type=script&lang=js&"
export * from "./EventStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports